import Vue from 'vue'
import App from './App'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#au-sentiment-widget',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js